import {
    GET_LIST_PRESCRIPTION_TEMPLATE,
    GET_SPECIFIC_PRESCRIPTION_TEMPLATE,
    UPDATE_SPECIFIC_PRESCRIPTION_TEMPLATE,
    CREATE_NEW_PRESCRIPTION_TEMPLATE,
    REMOVE_PRESCRIPTION_TEMPLATE,
    GET_PRESCRIPTION_TEMPLATE_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state cho module PrescriptionTemplate
 */
const INIT_STATE = {
    prescriptionTemplateList: [],
    currentPrescriptionTemplate: null,
    prescriptionTemplateActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PRESCRIPTION_TEMPLATE: {
            return {
                ...state,
                prescriptionTemplateList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            };
        }

        case GET_PRESCRIPTION_TEMPLATE_ACTIVE: {
            return {
                ...state,
                prescriptionTemplateActiveList: action.payload?.data || [],
            };
        }

        case GET_SPECIFIC_PRESCRIPTION_TEMPLATE: {
            return { ...state, currentPrescriptionTemplate: action.payload };
        }

        case CREATE_NEW_PRESCRIPTION_TEMPLATE: {
            return {
                ...state,
                prescriptionTemplateList: [action.payload, ...state.prescriptionTemplateList],
                prescriptionTemplateActiveList: [action.payload, ...state.prescriptionTemplateActiveList],
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total + 1
                }
            };
        }

        case UPDATE_SPECIFIC_PRESCRIPTION_TEMPLATE: {
            const updatedList = state.prescriptionTemplateList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            const updatedActiveList = state.prescriptionTemplateActiveList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                prescriptionTemplateList: updatedList,
                prescriptionTemplateActiveList: updatedActiveList
            };
        }

        case REMOVE_PRESCRIPTION_TEMPLATE: {
            const filteredList = state.prescriptionTemplateList.filter(
                item => !action.payload.includes(item.id)
            );
            const filteredActiveList = state.prescriptionTemplateActiveList.filter(
                item => !action.payload.includes(item.id)
            );

            return {
                ...state,
                prescriptionTemplateList: filteredList,
                prescriptionTemplateActiveList: filteredActiveList
            };
        }

        default:
            return { ...state };
    }
};
